import { useEffect, useState } from "react";
import { useApp } from "@/app/AppContext";
import { api } from "@/auth/session";

// Signed media URLs (GET /api/v3/media/:storage_key, 15-minute expiry).
// Cached per key for 12 minutes; never builds raw blob paths (fieldguide §10).
const cache = new Map<string, { url: string; at: number }>();
const TTL = 12 * 60_000;

export function useMediaUrl(storageKey?: string | null, type: "whatsapp" | "field_note_attachment" = "whatsapp") {
  const { mode } = useApp();
  const [url, setUrl] = useState<string | null>(() => (storageKey && fresh(storageKey)) || null);
  useEffect(() => {
    if (mode === "demo" || !storageKey) return;
    const hit = fresh(storageKey);
    if (hit) { setUrl(hit); return; }
    let alive = true;
    api<{ url: string }>(`/api/v3/media/${encodeURIComponent(storageKey)}?type=${type}`)
      .then((r) => { cache.set(storageKey, { url: r.url, at: Date.now() }); if (alive) setUrl(r.url); })
      .catch(() => {});
    return () => { alive = false; };
  }, [storageKey, mode, type]);
  return url;
}

function fresh(k: string) {
  const c = cache.get(k);
  return c && Date.now() - c.at < TTL ? c.url : null;
}
